import {
  setItem,
  removeItem,
  getItem
} from '../../../utils/localStorage';
import isEmpty from 'lodash/isEmpty';

export function isTokenPresent() { return !isEmpty(getItem('authenticationToken')); }
export function getToken() { return getItem('authenticationToken'); }
export function removeToken() { removeItem('authenticationToken'); }
export function setToken(token) { setItem('authenticationToken', token); }
